export default {
      id: "project-type-chat-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#project-type-chat-usage",
      toString: function () {
        return this.url;
      }
    }